import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import TechDueDiligenceComponent from '@components/tech-due-diligence/tech-due-diligence';

const TechDueDiligence = () => {
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Tech Due Diligence Checklist for Investors | Agilie',
          description:
            'Download the free tech due diligence checklist for investors. Know what to look for in a software company before you write the cheque.',
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout>
        <TechDueDiligenceComponent />
      </MainLayout>
    </>
  );
};

export default TechDueDiligence;
